import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: { main: "#00BC84", contrastText: "#d5d8e2" },
    secondary: { main: "#ffffff" }
  },
  spacing: 8,
  typography: {
    fontFamily: "'Noto Sans', sans- serif",
    useNextVariants: true,
    subtitle1: {
      fontSize: "1rem",
      //color: "#ffffff",
      fontWeight: "normal"
      //marginTop: "-20px",
      //marginBottom: "20px"
    },
    // h3: {
    //   color: "#ffffff",
    //   textAlign: "left",
    //   marginBottom: 10,
    //   marginLeft: 47,
    //   fontSize: 28
    // },
    h6: {
      marginLeft: 10,
      cursor: "pointer"
    },
    // h5: {
    //   color: "#ffffff!important",
    //   fontSize: "16px"
    // },
    h4: {
      color: "#000000!important",
      fontSize: "2.125rem;"
    },
    body1: {
      color: "#b3b3b3",
      fontSize: 16,
      width: "100%",
      marginLeft: 10,
      marginBottom: 25
    },
    body2: {
      marginLeft: 10
    },
    caption: {
      float: "right",
      marginRight: "5px",
      textTransform: "none",
      color: "#0000008a"
    }
  },
  status: {
    success: "#18be93",
    danger: "#ec4067",
    notStarted: "#bcc0d0",
    pendingSync: "#bcc0d0"
  },
  button: {
    login: "#fa0050",
    clever: "#4274f6",
    classlink: "#35abcd",
    primary: "#2e66e7"
  },
  icon: {
    login: "#9c9c9c"
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js